import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { OFFICES_PAGE } from '../content';

const Offices = () => {
  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-green-50 via-white to-emerald-50 py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Nos <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600">agences</span> en France
            </h1>
            <p className="text-xl text-gray-600">
              RT Distribution se développe sur tout le territoire avec 3 agences et de nouveaux projets d'ouverture
            </p>
          </div>
        </div>
      </section>

      {/* Offices Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {OFFICES_PAGE.offices.map((office) => (
              <div
                key={office.id}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100"
              >
                <div className="h-2 bg-gradient-to-r from-green-500 to-emerald-600" />
                <div className="p-8">
                  <div className="flex items-start justify-between mb-6">
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">{office.city}</h3>
                      <span className="inline-block px-3 py-1 bg-green-100 text-green-700 text-sm font-medium rounded-full">
                        {office.type}
                      </span>
                    </div>
                    <div className="w-12 h-12 bg-gradient-to-br from-green-100 to-emerald-100 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                      <MapPin className="text-green-600" size={24} />
                    </div>
                  </div>
                  <p className="text-gray-600 mb-6">{office.description}</p>
                  <div className="space-y-3">
                    <div className="flex items-start space-x-3">
                      <MapPin className="text-green-600 flex-shrink-0 mt-1" size={18} />
                      <div>
                        <p className="text-sm font-medium text-gray-900">{office.region}</p>
                        <p className="text-sm text-gray-600">{office.address}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Expansion Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">{OFFICES_PAGE.expansion.title}</h2>
              <p className="text-xl text-gray-600">
                {OFFICES_PAGE.expansion.subtitle}
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{OFFICES_PAGE.expansion.ambition.title}</h3>
                  <div className="space-y-4">
                    {OFFICES_PAGE.expansion.ambition.paragraphs.map((paragraph, index) => (
                      <p key={index} className="text-gray-600 leading-relaxed">
                        {paragraph}
                      </p>
                    ))}
                  </div>
                </div>
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-8">
                  <h4 className="text-xl font-bold text-gray-900 mb-6">{OFFICES_PAGE.expansion.stats.title}</h4>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <span className="text-gray-600">{OFFICES_PAGE.expansion.stats.current.label}</span>
                      <span className="text-2xl font-bold text-green-600">{OFFICES_PAGE.expansion.stats.current.value}</span>
                    </div>
                    <div className="h-px bg-gray-200" />
                    <div className="flex items-center justify-between">
                      <span className="text-gray-600">{OFFICES_PAGE.expansion.stats.growth2024.label}</span>
                      <span className="text-2xl font-bold text-green-600">{OFFICES_PAGE.expansion.stats.growth2024.value}</span>
                    </div>
                    <div className="h-px bg-gray-200" />
                    <div className="flex items-center justify-between">
                      <span className="text-gray-600">{OFFICES_PAGE.expansion.stats.goal2026.label}</span>
                      <span className="text-2xl font-bold text-green-600">{OFFICES_PAGE.expansion.stats.goal2026.value}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Offices;
